import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'booleanTranslator',
    standalone: false
})
export class BooleanTranslatorPipe implements PipeTransform {

  transform(value: boolean): string {
    return value ? 'Sim' : 'Não';
  }

}
